<template>
    <app-button-template :text="text" :buttonType="'primary'" :isLoading="isLoading"></app-button-template>
</template>

<script>
    import AppButtonTemplate from '@/components/ui/buttons/AppButtonTemplate';

    export default {
        name: 'appButtonSecondary',

        props: {
            text: String,
            disabled: Boolean,
            isLoading: Boolean,
        },

        components: {
            AppButtonTemplate
        }
    }
</script>

<style scoped lang="scss">

</style>
